import { render, staticRenderFns } from "./centCommission.vue?vue&type=template&id=01138a08&scoped=true&"
import script from "./centCommission.vue?vue&type=script&lang=js&"
export * from "./centCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01138a08",
  null
  
)

export default component.exports